<div class="{{themeFontClass}}" *ngIf="!isPrintPage">
    <div id="wrapper" [attr.data-theme]="themeDarkClass" [attr.data-theme]="themeHighContClass"
        class="{{themeClass}} {{rtlClass}}">

        <div class="page-loader-wrapper" *ngIf="isStopLoading">
            <div class="loader">
                <div class="m-t-30"><img src="./assets/website/img/logo.png" width="48" height="48" alt="Iconic" class="web-app-logo w-100"></div>
                <p>Please wait...</p>
            </div>
        </div>

        <!-- Top navbar div start -->
        <app-top-menu *ngIf="!isHorizontalMenu"></app-top-menu>

        <!-- main left menu -->
        <app-leftbar *ngIf="!isHorizontalMenu"></app-leftbar>

        <!-- Horizontal menu -->
        <ico-h-menu *ngIf="isHorizontalMenu"></ico-h-menu>

        <!-- mani page content body part -->
        <div id="main-content">
            <div class="p-0" [ngClass]="{'container': isHorizontalMenu, 'container-fluid': !isHorizontalMenu}">
                <router-outlet (activate)="getActiveRoutes()"></router-outlet>
            </div>
        </div>
    </div>
</div>

<div class="{{themeFontClass}}" *ngIf="isPrintPage">
    <div id="wrapper" [attr.data-theme]="themeDarkClass" [attr.data-theme]="themeHighContClass"
        class="{{themeClass}} {{rtlClass}}">
        <router-outlet (activate)="getActiveRoutes()"></router-outlet>
    </div>
</div>